import certified from "./assets/certified.svg";
import coffeeBeans from "./assets/coffee-beans.svg";
import coffee from "./assets/coffee.svg";
import freeDelivery from "./assets/free-delivery.svg";

import menu1 from "./assets/01.jpg";
import menu2 from "./assets/02.jpg";
import menu3 from "./assets/03.jpg";
import menu4 from "./assets/04.jpg";
import menu5 from "./assets/05.jpg";
import menu6 from "./assets/06.jpg";
import menu7 from "./assets/07.jpg";
import menu8 from "./assets/08.jpg";

import gallery1 from "./assets/gallery-1.jpg";
import gallery2 from "./assets/gallery-2.jpg";
import gallery3 from "./assets/gallery-3.jpg";
import gallery4 from "./assets/gallery-4.jpg";
import gallery5 from "./assets/gallery-5.jpg";
import gallery6 from "./assets/gallery-6.jpg";
import gallery7 from "./assets/gallery-7.jpg";
import gallery8 from "./assets/gallery-8.jpg";
import gallery9 from "./assets/gallery-9.jpg";
import gallery0 from "./assets/gallery-0.jpg";
import gallery11 from "./assets/gallery-11.jpg";
import gallery12 from "./assets/gallery-12.jpg";

import offer1 from "./assets/offer-1.jpg";
import offer2 from "./assets/offer-2.jpg";

import testimonial1 from "./assets/testimonial-1.jpg";
import testimonial2 from "./assets/testimonial-2.jpg";
import testimonial3 from "./assets/testimonial-3.jpg";
import testimonial4 from "./assets/testimonial-4.jpg";

export const links = [
  {
    name: "Home",
    path: "home",
  },
  {
    name: "About",
    path: "about",
  },
  {
    name: "Features",
    path: "features",
  },
  {
    name: "Menu",
    path: "menu",
  },
  {
    name: "Gallery",
    path: "gallery",
  },
  {
    name: "Chefs",
    path: "team"
  },
  {
    name: "Testimonials",
    path: "testimonials",
  },
];

export const features = [
  {
    id: 1,
    img: freeDelivery,
    title: "Free Shipping",
    description:
      "It is a long established fact that a reader will be by the readable content of a page looking at its layout.",
  },
  {
    id: 2,
    img: certified,
    title: "Organic Certified",
    description:
      "It is a long established fact that a reader will be by the readable content of a page looking at its layout.",
  },
  {
    id: 3,
    img: coffee,
    title: "High Quality",
    description:
      "It is a long established fact that a reader will be by the readable content of a page looking at its layout.",
  },
  {
    id: 4,
    img: coffeeBeans,
    title: "Proper Roasting",
    description:
      "It is a long established fact that a reader will be by the readable content of a page looking at its layout.",
  },
];

export const menu = [
  {
    id: 1,
    img: menu1,
    title: "Americano Coffee",
    description: "Milk with vanilla flavored",
    price: 18,
  },
  {
    id: 2,
    img: menu2,
    title: "Cappuccino Arabica",
    description: "Milk with vanilla flavored",
    price: 18,
  },
  {
    id: 3,
    img: menu3,
    title: "Milk Cream Coffee",
    description: "Milk with vanilla flavored",
    price: 15,
  },
  {
    id: 4,
    img: menu4,
    title: "Special Raw Coffee",
    description: "Milk with vanilla flavored",
    price: 20,
  },
  {
    id: 5,
    img: menu5,
    title: "Hot Lemon Tea",
    description: "Traditional tea with lemon in it",
    price: 12,
  },
  {
    id: 6,
    img: menu6,
    title: "Mix coffelatte",
    description: "Milk with vanilla flavored",
    price: 15,
  },
  {
    id: 7,
    img: menu7,
    title: "Traditional tea",
    description: "Traditional served tea with pot",
    price: 10,
  },
  {
    id: 8,
    img: menu8,
    title: "Cold Coffee",
    description: "Milk with vanilla flavored",
    price: 15,
  },
];

export const menux = [
  {
    id: 1,
    img: menu1,
    title: "Nasi Ayam",
    description: "Nasi dengan suwiran daging ayam matang",
    price: 50.25,
  },
  {
    id: 2,
    img: menu2,
    title: "Mie Goreng / rebus",
    description: "Mie biasa yang digoreng / direbus",
    price: 70.25,
  },
  {
    id: 3,
    img: menu3,
    title: "Tahu Goreng",
    description: "Tahu yang dimasukkan minyak panas",
    price: 30.25,
  },
  {
    id: 4,
    img: menu4,
    title: "Onion Ring",
    description: "Bawang bombay goreng gurih kriuk",
    price: 80.25,
  },
  {
    id: 5,
    img: menu5,
    title: "Roti Bakar",
    description: "Roti panggang sih tepatnya dengan keju atau messes",
    price: 90.25,
  },
  {
    id: 6,
    img: menu6,
    title: "Pisang Goreng",
    description: "Sudah dikupas lalu digoreng",
    price: 70.25,
  },
  {
    id: 7,
    img: menu7,
    title: "Bebek Sambal Hitam",
    description: "Dicoba dulu saja, jamina enak",
    price: 120.25,
  },
  {
    id: 8,
    img: menu8,
    title: "Nasi Goreng",
    description: "Dijamin lebih enak dari abang pinggir jalan",
    price: 40.25,
  },
]

export const gallery = [
  {
    id: 1,
    img: gallery1,
    title: "Kopi",
  },
  {
    id: 2,
    img: gallery2,
    title: "Tembakau pilihan",
  },
  {
    id: 3,
    img: gallery3,
    title: "Aneka Jus",
  },
  {
    id: 4,
    img: gallery4,
    title: "Wedang Uwuh",
  },
  {
    id: 5,
    img: gallery5,
    title: "Dua piring ayam suwir",
  },
  {
    id: 6,
    img: gallery6,
    title: "Silakan dipilih",
  },
  {
    id: 7,
    img: gallery7,
    title: "Lokasi Pesan",
  },
  {
    id: 8,
    img: gallery8,
    title: "Lokasi Pesan",
  },
  {
    id: 9,
    img: gallery9,
    title: "Lokasi Pesan",
  },
  {
    id: 0,
    img: gallery0,
    title: "Lokasi Pesan",
  },
  {
    id: 11,
    img: gallery11,
    title: "Lokasi Pesan",
  },
  {
    id: 12,
    img: gallery12,
    title: "Lokasi Pesan",
  },
];

export const offer = [
  {
    id: 1,
    img: offer1,
    title: "Teh Jahe panas",
    discount: "Get 10% Offer",
    description:
      "Penghangat badan ketika musim dingin disertai pilek, seruput ketika masih hangat",
  },
  {
    id: 2,
    img: offer2,
    title: "Es Kopi",
    discount: "Get 10% Offer",
    description:
      "Bagi yang ingin nyobain kopi tapi pakai es dan gula, dipersilakan",
  },
];

export const testimonials = [
  {
    id: 1,
    img: testimonial1,
    title: 'Kimora T',
    service: 'Customer',
    description:
      'Kedai kopi kecil dipinggir uns suasananya homie banget, kemaren iseng nyoba kesini mampir dan ternyata kopi sama makanannya enak banget terutama ayam gepreknya sambelnya bikin nagihh pedes pol wkwkwk buat yg mau nugas disini juga bisa banget soalnya tempatnya suport, tenang banget dr bising (tp kalo musik ttp ada ya)',
  },
  {
    id: 2,
    img: testimonial2,
    title: 'Swastika L',
    service: 'Customer',
    description:
      'Wedang rempahnya favorit! Nyobain wedang telang, ternyata sajiannya lengkap (disediain bunga rosella, jeruk nipis, sereh sama gula batu buat campurannya). Wedang jahe susunya juga enak! Pokoknya kalo ke solo dan pengen cari yang anget2 wajib ke sini',
  },
  {
    id: 3,
    img: testimonial3,
    title: 'Krismona D',
    service: 'Customer',
    description:
      'Recommended bgt dijadiin tempat nongkrong. Seperti namanya, tempat ini selain sebagai tempat ngopi, juga menjual berbagai jenis tembakau. Tempatnya luas dan menyebar, bisa indoor maupun outdoor. Tenang aja, ada mushola dan toiletnya juga kok. Waktu ke sini aku pesen Almond Latte. Rasanya tidak mengecewakan. Harga menu-menunya pun masih termasuk terjangkau. Pembayaran bisa tunai maupun non-tunai. Tersedia beberapa mainan seperti kartu uno, catur, dll. Wifi pun ada. Jika beruntung, kalian bisa dengerin live music dari mas-mas ISI Solo🙌',
  },
  {
    id: 4,
    img: testimonial4,
    title: "Gordon D Novak",
    service: "Customer",
    description:
      "There are many variations passages of the available but the majority have suffered to the alteration in some form by injected of humour or randomised words.",
  },
];